<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Benvenuto />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Benvenuto from '@/views/Benvenuto.vue'

export default {
  name: 'Home',
  components: {
    //HelloWorld,
    Benvenuto
  }
}
</script>
